import { useFormaliteService } from '@europrocurement/l2d-domain';
import { ReglementsEtAcomptesCBJsonldAcompteRead } from '@europrocurement/l2d-domain/openApi/ApiFormalite';

export type CollectionProvisionType = ReglementsEtAcomptesCBJsonldAcompteRead;

const useCollectionProvision = () => {
    const { acomptesApi } = useFormaliteService();
    let searchFormalisteTimeout: number | undefined;

    const searchCollectionProvision = (
        collectionIds: number[],
    ): Promise<Array<CollectionProvisionType>> =>
        new Promise((resolve, reject) => {
            clearTimeout(searchFormalisteTimeout);
            searchFormalisteTimeout = setTimeout(() => {
                acomptesApi
                    .apiAcomptesGetCollection({ detailsReglementsIdCollectionId2: collectionIds })
                    .then((res) =>
                        resolve(res.data['hydra:member'] as Array<CollectionProvisionType>),
                    )
                    .catch(() => reject());
            }, 300);
        });

    return { searchCollectionProvision };
};

export default useCollectionProvision;
